import React, {Component} from 'react';
import { Link } from "react-router-dom";
import GlobalVariable from "../../GlobalVariable";
import api, { isUnauthorizedError, redirectToLogin } from "../../api";
import { AVATAR_UPDATED_EVENT, avatarUrlFromResponse } from '../../avatar';
import ReactDOM from 'react-dom';
import Menu from "../Menu";
import Preloader from "../Preloader";
import './Home.scss';
import { fetchStaffNotifications } from "../Notifications/idpNotifications";
import {getRecordComment} from '../Record/recordComment';
import NoPlanCard from './NoPlanCard';

const EMPLOYEE_BOOK_URL = 'https://drive.google.com/file/d/1mZFhmePjVhM9iJ2X3QrvjCxgimE7KfVP/view?usp=sharing';

export class Home extends Component<any, any> {
    private moodRequestInFlight = false;

    constructor(props: any) {
        super(props);
        window.scrollTo(0, 0);
        this.state = {
            staff: '',
            events: [],
            service: [],
            dateTime: '',
            activeBlock: '',
            openChangePoint: false,
            isLoad: false,
            auth: false,
            countNextRecord: 0,
            chioCoin: 0,
            activeCompany: [],
            record: [],
            recordsLoading: true,
            recordsError: '',
            notificationUnreadCount: 0,
            planningDashboard: null,
            planningLoading: true,
            planningError: '',
            moodSubmitting: false,
            moodSent: false,
            selectedMood: '',
            moodModalOpen: false,
            moodError: '',
            tipsToday: 0,
            quickSheet: '',
            headerAvatarUrl: '',
            headerProfileName: 'Мастер',

            // === Новое: состояние модалки-интро ===
            introModalOpen: false,
            introModal: {
                key: '',
                title: '',
                text: '',
                videoUrl: ''
            },
            introMarking: false,
        };
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.changeStatus = this.changeStatus.bind(this);
    }

    private formatNotificationBadge = (count: number): string => {
        if (count > 99) return '99+';
        return String(count);
    };

    private fetchNotificationIndicator = async () => {
        try {
            const result = await fetchStaffNotifications(1);
            const unreadCount = Number(result?.data?.unreadCount ?? 0);
            this.setState({ notificationUnreadCount: unreadCount > 0 ? unreadCount : 0 });
        } catch {
            this.setState({ notificationUnreadCount: 0 });
        }
    };

    private fetchPlanningDashboard = async () => {
        try {
            this.setState({planningLoading: true});
            const result = await api({
                url: GlobalVariable.host() + '/widget/staff/v2/planning/dashboard',
                method: 'GET',
                withCredentials: true,
                headers: {'Content-Type': 'application/json'},
            });
            if (result.data?.company?.id) {
                // The Staff API selects a workplace the authenticated master can access.
                // The legacy home response may contain a salon visited as a customer.
                sessionStorage.setItem('staffCompanyActive', JSON.stringify(result.data.company));
            }
            this.setState({planningDashboard: result.data, planningLoading: false, planningError: ''});
        } catch (error) {
            const code = error?.response?.data?.error;
            this.setState({
                planningDashboard: null,
                planningLoading: false,
                planningError: code === 'staff_profile_not_found' ? 'profile' : 'load',
            });
        }
    };

    private getMoodStorageKey = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = (`0${today.getMonth() + 1}`).slice(-2);
        const day = (`0${today.getDate()}`).slice(-2);
        return `staffMoodCheckin:${year}-${month}-${day}`;
    };

    private getStoredMood = () => {
        try {
            const value = localStorage.getItem(this.getMoodStorageKey()) || '';
            return ['happy', 'neutral', 'sad'].indexOf(value) >= 0 ? value : (value === 'sent' ? 'sent' : '');
        } catch {
            return '';
        }
    };

    private shouldShowMoodModal = () => {
        try {
            return !localStorage.getItem(this.getMoodStorageKey());
        } catch {
            return true;
        }
    };

    private openMoodModalIfNeeded = () => {
        const storedMood = this.getStoredMood();
        if (storedMood) {
            this.setState({
                moodSent: true,
                selectedMood: storedMood === 'sent' ? '' : storedMood,
                moodModalOpen: false,
                moodError: '',
            });
            return;
        }

        if (this.state.auth && this.shouldShowMoodModal()) {
            this.setState({moodModalOpen: true, moodError: ''});
        }
    };

    private fetchMoodStatus = async () => {
        try {
            const result = await api({
                url: GlobalVariable.host() + '/widget/staff/v2/mood',
                method: 'GET',
                withCredentials: true,
            });
            const mood = result?.data?.mood;
            if (['happy', 'neutral', 'sad'].indexOf(mood) >= 0) {
                try {
                    localStorage.setItem(this.getMoodStorageKey(), mood);
                } catch {
                    // Server remains the source of truth when storage is unavailable.
                }
                this.setState({moodSent: true, selectedMood: mood, moodModalOpen: false});
            } else {
                try {
                    localStorage.removeItem(this.getMoodStorageKey());
                } catch {
                    // ignore
                }
                this.setState({moodSent: false, selectedMood: '', moodModalOpen: true});
            }
        } catch {
            this.openMoodModalIfNeeded();
        }
    };

    private money = (value: any) => `${Number(value || 0).toLocaleString('ru-RU')} ₽`;

    private fetchTipsDashboard = async () => {
        try {
            const result = await api({
                url: '/widget/cloud-payments/dashboard',
                method: 'GET',
                withCredentials: true,
                headers: {'Content-Type': 'application/json'},
            });
            const tipsToday = Number(result?.data?.overallTotals?.today || 0);
            this.setState({tipsToday: tipsToday > 0 ? tipsToday : 0});
        } catch {
            this.setState({tipsToday: 0});
        }
    };

    private initials(value: string): string {
        const parts = String(value || '').trim().split(/\s+/).filter(Boolean);
        if (!parts.length) return 'М';
        if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }

    private headerAvatarRevision = 0;

    private fetchHeaderAvatar = async () => {
        const revision = this.headerAvatarRevision;
        try {
            const result = await api({
                url: GlobalVariable.staffBack() + '/mobile/profile/avatar/',
                method: 'GET',
                withCredentials: true,
                headers: {'Accept': 'application/json'},
            });
            if (revision === this.headerAvatarRevision) {
                this.setState({headerAvatarUrl: avatarUrlFromResponse(result.data)});
            }
        } catch {
            // avatar is optional in the home header
        }
    };

    private fetchHeaderProfile = async () => {
        try {
            const result = await api({
                url: GlobalVariable.host() + '/widget/profile/show',
                headers: {'Content-Type': 'application/json'},
                withCredentials: true,
                method: 'GET',
            });
            const data = result.data || {};
            const headerProfileName = data.name || data.fio || data.client || 'Мастер';
            this.setState({headerProfileName});
            this.fetchHeaderAvatar();
        } catch {
            this.fetchHeaderAvatar();
        }
    };

    private submitMood = async (mood: string) => {
        if (this.moodRequestInFlight || this.state.moodSent) {
            return;
        }
        this.moodRequestInFlight = true;
        this.setState({moodSubmitting: true, selectedMood: mood, moodError: ''});
        try {
            const result = await api({
                url: GlobalVariable.host() + '/widget/staff/v2/mood',
                method: 'POST',
                withCredentials: true,
                headers: {'Content-Type': 'application/json'},
                data: {mood},
            });
            if (result?.data?.ok !== true || result?.data?.mood !== mood) {
                throw new Error('Unexpected mood save response');
            }
            try {
                localStorage.setItem(this.getMoodStorageKey(), mood);
            } catch {
                // ignore
            }
            this.setState({moodSubmitting: false, moodSent: true, moodModalOpen: false});
        } catch {
            this.setState({moodSubmitting: false, moodError: 'Не удалось сохранить ответ. Попробуйте ещё раз.'});
        } finally {
            this.moodRequestInFlight = false;
        }
    };

    updateData = (value: any) => { this.setState({activeBlock: value}) }
    updateService = (value: any) => {
        sessionStorage.setItem("serviceActive", JSON.stringify(value));
        this.setState({service: value, activeBlock: 'menu'})
    }
    updateStaff = (value: any) => {
        sessionStorage.setItem("staffActive", JSON.stringify(value));
        this.setState({staff: value, activeBlock: 'menu'})
    }
    updateDateTime = (value: any) => {
        sessionStorage.setItem("dateTime", JSON.stringify(value));
        this.setState({dateTime: value, activeBlock: 'menu'})
    }
    updateCompany = (value: any) => {
        sessionStorage.setItem("companyActive", JSON.stringify(value));
        this.setState({activeCompany: value, activeBlock: 'menu'})
    }

    // === Новое: подгрузка активной промо-модалки ===
    private fetchPromoModal = async () => {
        try {
            const url = `${GlobalVariable.staffBack()}/api/promo/current`;
            const r = await api.get(url, { withCredentials: true });
            const data = r?.data;
            if (data?.modal && data?.viewed === false) {
                this.setState({
                    introModalOpen: true,
                    introModal: {
                        key: data.modal.key || '',
                        title: data.modal.title || '',
                        text: data.modal.text || '',
                        videoUrl: data.modal.videoUrl || ''
                    }
                });
            }
        } catch {
            // молча
        }
    }

    // === Новое: закрытие модалки и отметка просмотра ===
    private closeIntroModal = async () => {
        const { introModal, introMarking } = this.state;
        if (!introModal?.key || introMarking) {
            this.setState({ introModalOpen: false });
            return;
        }
        this.setState({ introMarking: true });
        try {
            const url = `${GlobalVariable.staffBack()}/api/promo/mark-viewed`;
            await api.post(url, { key: introModal.key }, {
                headers: {'Content-Type': 'application/json'},
                withCredentials: true,
            });
        } catch {
            // не блокируем закрытие
        } finally {
            this.setState({ introModalOpen: false, introMarking: false });
        }
    }

    componentDidMount() {
        window.addEventListener(AVATAR_UPDATED_EVENT, this.onAvatarUpdated);
        document.addEventListener('click', this.handleClickOutside, true);

        let urlAPI = GlobalVariable.host() + '/widget/staff/home';
        const data = {};
        api({
            url: urlAPI,
            headers: {'Content-Type': 'application/json'},
            method: "POST",
            data: data,
            withCredentials: true,
        }).then(result => {
            // Keep the company selected by the authenticated Staff bootstrap
            // available to feature pages opened later (including marking).
            // Previously only the unused updateCompany callback wrote this
            // value, so multi-salon users could silently fall back to the
            // first company on the backend.
            sessionStorage.setItem("companyActive", JSON.stringify(result.data));
            this.setState({
                activeCompany: result.data,
                datework: result.data.days,
                countNextRecord: result.data.countNextRecord,
                isLoad: true,
                auth: true
            }, () => {
                this.fetchPromoModal();
                this.fetchPlanningDashboard();
                this.fetchMoodStatus();
                this.fetchTipsDashboard();
                this.fetchHeaderProfile();
            })
            this.fetchNotificationIndicator();
        }).catch(error => {
            if (isUnauthorizedError(error)) {
                redirectToLogin();
                return;
            }
            this.clientInfoNoAuth()
            this.setState({ auth: false, isLoad: true, notificationUnreadCount: 0 })
        })

        let urlAPI2 = GlobalVariable.staffBack() + '/getEventsNext';
        const data2 = {};
        api({
            url: urlAPI2,
            headers: {'Content-Type': 'application/json'},
            method: "GET",
            data: data2,
            withCredentials: true,
        }).then(result => {
            this.setState({ events: result.data })
        }).catch(() => {
            this.setState({ events: [] })
        })

        let urlAPI3 = GlobalVariable.host() + '/widget/staff/v1/profile/my-record/next';
        var date = new Date();

        function leadingZero(token: any) { return ("0" + token).slice(-2) }

        var year = date.getFullYear(),
            month = leadingZero(date.getMonth() + 1),
            day = leadingZero(date.getDate()),
            hours = leadingZero(date.getHours()),
            minutes = leadingZero(date.getMinutes())

        var result = `${year}-${month}-${day} ${hours}:${minutes}`;

        const data3 = { 'dateTime': result, 'limit': 2 };
        this.setState({recordsLoading: true, recordsError: ''});
        api({
            url: urlAPI3,
            headers: {'Content-Type': 'application/json'},
            method: "post",
            data: data3,
            withCredentials: true,
        }).then(result => {
            this.setState({
                record: Array.isArray(result.data) ? result.data : [],
                recordsLoading: false,
                recordsError: '',
            })
        }).catch(() => {
            this.setState({
                record: [],
                recordsLoading: false,
                recordsError: 'Не удалось загрузить ближайшие записи',
            })
        })

        const data4 = { 'dateTime': result, 'limit': 2 };
        let urlAPI4 = GlobalVariable.staffBack() + '/getChioCoin';
        api({
            url: urlAPI4,
            headers: {'Content-Type': 'application/json'},
            method: "post",
            data: data4,
            withCredentials: true,
        }).then(result => {
            this.setState({ chioCoin: result.data.chioCoin })
        }).catch(() => {
            this.setState({ chioCoin: 0 })
        })

    }

    clientInfoNoAuth() {
        document.addEventListener('click', this.handleClickOutside, true);
        let urlAPI = GlobalVariable.host() + '/open/client/home';
        const data = {};
        api({
            url: urlAPI,
            headers: {'Content-Type': 'application/json'},
            method: "POST",
            data: data,
            withCredentials: true,
        }).then(result => {
            this.setState({
                activeCompany: result.data,
                datework: result.data.days,
                isLoad: true,
                auth: false
            })
        }).catch(() => {
            this.setState({ auth: false, isLoad: true, notificationUnreadCount: 0 })
        })
    }

    componentWillUnmount() {
        ++this.headerAvatarRevision;
        window.removeEventListener(AVATAR_UPDATED_EVENT, this.onAvatarUpdated);
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    private onAvatarUpdated = (event: Event) => {
        ++this.headerAvatarRevision;
        this.setState({headerAvatarUrl: (event as CustomEvent).detail?.url || ''});
    };

    changeStatus() { this.setState({openChangePoint: true}) }

    handleClickOutside = (event: any) => {
        const domNode = ReactDOM.findDOMNode(this);
        if (this.state.openChangePoint === true) {
            if ((event.target as HTMLElement).className === "changePointBlock") {
                this.setState({openChangePoint: false})
            }
        }
        void domNode;
    }

    // === Новое: рендер полноэкранной модалки с текстом и видео ===
    private renderIntroModal() {
        if (!this.state.introModalOpen) return null;
        const { title, text, videoUrl } = this.state.introModal || {};
        return (
            <div className="intro-modal-overlay" role="dialog" aria-modal="true">
                <div className="intro-modal">
                    <button className="intro-modal-close" onClick={this.closeIntroModal} aria-label="Закрыть">
                        ✕
                    </button>
                    <div className="intro-modal-content">
                        {title ? <h2 className="intro-modal-title">{title}</h2> : null}
                        {text ? <div className="intro-modal-text" dangerouslySetInnerHTML={{__html: text}} /> : null}
                        {videoUrl ? (
                            <div className="intro-modal-video-wrap">
                                <video
                                    className="intro-modal-video"
                                    src={videoUrl}
                                    controls
                                    playsInline
                                    preload="metadata"
                                    onEnded={this.closeIntroModal}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }

    renderChangePoint() {
        if (this.state.openChangePoint === true) {
            return (
                <div className={'changePointBlock'}>
                    <div className={'changePoint'}>
                        <div className={'block-address mt-3 mb-3'}>
                            {this.state.activeCompany.city}, {this.state.activeCompany.address}
                        </div>
                        <div className={'block-work mb-3'}>
                            <div>Режим работы:</div>
                            {this.state.datework}
                        </div>
                        <div className={'block-phone mb-3'}>
                            <div>Телефон:</div>
                            <div>8 800 600-65-16</div>
                        </div>
                        <Link to={'/country'}>
                            <div className={'btn-active mt-3 mb-3'}>Сменить филиал</div>
                        </Link>
                    </div>
                </div>
            )
        }
    }

    renderBlockBalls() {
        if (this.state.auth === true) {
            return (<div className={'title'}>{this.state.activeCompany.ball} баллов</div>)
        } else {
            return (<div className={'title'}>Мои баллы</div>)
        }
    }

    renderBlockName() {
        if (this.state.auth === true) {
            return (
                <div>
                    <div className='white-text txt'>Приветствуем в Чио Чио,</div>
                    <div className='white-text txt'>{this.state.activeCompany.nameClient}</div>
                </div>
            )
        }
    }

    renderCountRecord() { return (<div className={'title'}>График работы</div>) }

    renderRecord() {
        if (!this.state.activeCompany.recordOnline) {
            return (
                <div className={'body_block_record_and_history'}>
                    <div className={'block_record_and_history d-flex'}>
                        <div className={'onlineRecord'}>
                            <Link to={'/date'}>
                                <div className={'btn_block'}>
                                    <div className={'image'}>
                                        <img src={'/img/icon-staff.png'} alt=''/>
                                    </div>
                                    <div className={'title'}>Мои записи</div>
                                </div>
                            </Link>
                            <Link to={'/point'}>
                                <div className={'btn_block'}>
                                    <div className={'image'}>
                                        <img src={'/img/icon-service.png'} alt=''/>
                                    </div>
                                    <div className={'title'}>Статистика смены</div>
                                </div>
                            </Link>
                        </div>

                        <div className={'history'}>
                            <Link to={'/date-grafics'}>
                                <div className={'btn_block'}>
                                    <div className={'image'}>
                                        <img src={'/img/icon4.png'} alt=''/>
                                    </div>
                                    {this.renderCountRecord()}
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={'body_block_record_and_history'}>
                    <h2 className={'title'}>Записаться</h2>
                    <div className={'block_record_and_history d-flex'}>
                        <div className={'onlineRecord'}>
                            <div className={'no-record'}>
                                <div className={'image'}><img src={'/img/no-record.png'} alt=''/></div>
                                <div className={'text'}>Онлайн запись не доступна</div>
                            </div>
                        </div>
                        <div className={'history'}>
                            <div className={'btn_block'}>
                                <div className={'image'}><img src={'/img/icon4.png'} alt=''/></div>
                                {this.renderCountRecord()}
                            </div>
                            <div className={'btn_block'}>
                                <div className={'image'}><img src={'/img/ball-icon.png'} alt=''/></div>
                                {this.renderBlockBalls()}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    renderBlockActivePoint() {
        if (this.state.auth === true) {
            return (
                <div className='mx-w-content choose-town p-sides'>
                    <div className='p-3'>
                        <img className='ic-town' src={'/img/point.png'} alt=''/>
                        {this.state.activeCompany.city}, {this.state.activeCompany.address}
                        <img className='ic-arrow' src={'/img/arrowRight2.png'} alt=''/>
                    </div>
                </div>
            )
        } else {
            return (
                <div className='mx-w-content choose-town p-sides'>
                    <div className='p-3'>
                        <img className='ic-town' src={'/img/point.png'} alt=''/>
                        <span className='txt-middle'>Выберите город</span>
                        <img className='ic-arrow' src={'/img/arrowRight2.png'} alt=''/>
                    </div>
                </div>
            )
        }
    }

    renderNoRecords() {
        if (this.state.record.length === 0) {
            return (
                <div>
                    <div className='chio-card-subheader ml-3 mr-3 pl-3 pr-3 pt-2 d-flex justify-content-between '>
                        <span className='text-white txt-middle'></span>
                        <span className='text-white txt-middle'></span>
                    </div>
                    <div className='chio-card ml-3 mr-3 mb-2 pl-3 pr-3 pt-2 pb-2'>
                        <div className='d-flex'>
                            <div className='d-flex flex-column w-100'>
                                <div className='txt-middle bold mt-3 mb-3 text-center'>Ближайших записей не найдено</div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
    renderNoEvents() {
        if (this.state.events.length === 0) {
            return (
                <div>
                    <div className='chio-card-subheader ml-3 mr-3 pl-3 pr-3 pt-2 d-flex justify-content-between '>
                        <span className='text-white txt-middle'></span>
                        <span className='text-white txt-middle'></span>
                    </div>
                    <div className='chio-card ml-3 mr-3 mb-2 pl-3 pr-3 pt-2 pb-2'>
                        <div className='d-flex'>
                            <div className='d-flex flex-column w-100'>
                                <div className='txt-middle bold mt-3 mb-3 text-center'>Ближайших событий не найдено</div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    renderPlanningBlock() {
        if (!this.state.planningDashboard) {
            return (
                <div className='home-planning-card no-plan'>
                    <div className='home-planning-title'>План на сегодня</div>
                    <div className='home-planning-empty-note'>
                        {this.state.planningLoading ? 'Загружаем данные за сегодня…'
                            : this.state.planningError === 'profile'
                                ? 'План появится, когда профиль мастера будет привязан к вашему аккаунту. Если вы уже работаете в салоне, попросите управляющего проверить привязку.'
                                : 'Не удалось обновить план. Попробуйте ещё раз чуть позже.'}
                    </div>
                    {!this.state.planningLoading && this.state.planningError !== 'profile' &&
                        <button type='button' className='home-planning-retry' onClick={this.fetchPlanningDashboard}>Повторить</button>}
                </div>
            );
        }

        const data = this.state.planningDashboard || {};
        const progress = data.progress || {};
        const plan = data.plan || {};
        const planAmount = Number(plan.amount || progress.plan || 0);
        const percentValue = Number(progress.percent || 0);
        const percentLabel = Number.isFinite(percentValue) ? percentValue : 0;
        const percent = Math.max(0, Math.min(100, percentLabel));
        const hasPlan = planAmount > 0;
        const address = data.company?.address
            || data.company?.title
            || [this.state.activeCompany.city, this.state.activeCompany.address].filter(Boolean).join(', ');
        const revenue = Number(progress.revenue || 0);

        if (!hasPlan) {
            return <NoPlanCard address={address} revenue={revenue}/>;
        }

        return (
            <div className='home-planning-card has-plan'>
                <Link to='/planning' className='home-planning-main' aria-label='План на сегодня. Открыть планирование'>
                    <div className='home-planning-header'>
                        <div className='home-planning-heading'>
                            <div className='home-planning-title'>План на сегодня</div>
                            {address ? <div className='home-planning-address'>{address}</div> : null}
                        </div>
                        <div className='home-planning-percent'>
                            <span>{percentLabel}%</span><small>из {this.money(planAmount)}</small>
                        </div>
                    </div>
                    <div className='home-planning-revenue-label'>Моя выручка за сегодня</div>
                    <div className='home-planning-revenue'>{this.money(revenue)}</div>
                    <div className='home-planning-progress'>
                        <div className='home-planning-progress-fill' style={{width: `${percent}%`}}/>
                    </div>
                    <div className='home-planning-footer'>
                        <span>{progress.hint || 'Подсказка по плану появится позже'}</span>
                        <span>Цель на день</span>
                    </div>
                </Link>
            </div>
        );
    }

    private getMoodItems = () => ([
        {key: 'happy', label: 'Хорошо', icon: '😀'},
        {key: 'neutral', label: 'Нормально', icon: '😐'},
        {key: 'sad', label: 'Плохо', icon: '😞'},
    ]);

    renderMoodCard() {
        return (
            <div className='home-mood-card'>
                <div className='home-mood-copy'>
                    <div className='home-section-title'>Как дела?</div>
                    <div className='home-section-subtitle'>Ваше настроение помогает нам становиться лучше</div>
                    {this.state.moodError ? <div className='home-mood-error'>{this.state.moodError}</div> : null}
                </div>
                <div className='home-mood-actions' aria-label='Как дела?'>
                    {this.getMoodItems().map(item => (
                        <button
                            key={item.key}
                            type='button'
                            className={'home-mood-button ' + (this.state.selectedMood === item.key ? 'is-active' : '')}
                            onClick={() => this.submitMood(item.key)}
                            disabled={this.state.moodSubmitting || this.state.moodSent}
                            aria-label={item.label}
                        >
                            {item.icon}
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    renderRecordsBlock() {
        const records = this.state.record || [];

        return (
            <div className='home-records-card'>
                <div className='home-records-head'>
                    <div className='home-section-title'>Ближайшие записи</div>
                    <Link to='/records' className='home-records-link'>Все записи</Link>
                </div>
                {this.state.recordsLoading ? (
                    <div className='home-record-empty'>
                        <div className='home-record-empty-icon'>
                            <img src='/img/home-v2/calendar-empty.svg' alt=''/>
                        </div>
                        <div>
                            <div className='home-record-empty-title'>Загружаем записи</div>
                        </div>
                    </div>
                ) : this.state.recordsError ? (
                    <div className='home-record-empty'>
                        <div className='home-record-empty-icon'>
                            <img src='/img/home-v2/calendar-empty.svg' alt=''/>
                        </div>
                        <div>
                            <div className='home-record-empty-title'>{this.state.recordsError}</div>
                            <div className='home-record-empty-text'>Откройте все записи или обновите страницу</div>
                        </div>
                    </div>
                ) : records.length === 0 ? (
                    <div className='home-record-empty'>
                        <div className='home-record-empty-icon'>
                            <img src='/img/home-v2/calendar-empty.svg' alt=''/>
                        </div>
                        <div>
                            <div className='home-record-empty-title'>На сегодня записей нет</div>
                            <div className='home-record-empty-text'>Давайте добавим новую запись</div>
                        </div>
                    </div>
                ) : (
                    <div className='home-record-list'>
                        {records.map((itemRecord: any) => (
                            <Link to='/records' className='home-record-item' key={itemRecord.id ?? itemRecord.date + itemRecord.time}>
                                <div className='home-record-time'>
                                    <span>{itemRecord.time}</span>
                                    <small>{itemRecord.date}</small>
                                </div>
                                <div className='home-record-data'>
                                    <div className='home-record-client'>{itemRecord.client || 'Клиент'}</div>
                                    <div className='home-record-service'>{itemRecord.service || itemRecord.company || 'Запись'}</div>
                                    {getRecordComment(itemRecord) ? (
                                        <div className='home-record-comment'>
                                            Комментарий: {getRecordComment(itemRecord)}
                                        </div>
                                    ) : null}
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        );
    }

    renderHomeAction(item: any) {
        const className = 'home-action-row' + (item.primary ? ' is-primary' : '');
        const body = (
            <>
                <span className={'home-action-icon' + (item.iconLarge ? ' is-large' : '')}><img src={item.icon} alt=''/></span>
                <span className='home-action-copy'>
                    <span className='home-action-title'>{item.title}</span>
                    <span className='home-action-text'>{item.text}</span>
                </span>
                <span className='home-action-arrow'>›</span>
            </>
        );

        if (item.to) {
            return <Link key={item.title} to={item.to} className={className}>{body}</Link>;
        }

        return <button key={item.title} type='button' className={className} onClick={item.onClick}>{body}</button>;
    }

    renderActionsList() {
        const actions = [
            {title: 'Аналитика', text: 'Смотрите показатели и растите', icon: '/img/home-v2/png/analitika.png', to: '/analytics', primary: true},
            {title: 'Расчёт зарплаты', text: 'Начисления с учётом НДС', icon: '/img/home-v2/salary.svg', to: '/salary'},
            {title: 'График работы', text: 'Ваше расписание и смены', icon: '/img/home-v2/png/grafik_raboty.png', to: '/date-schedule-staffs'},
            {title: 'Бенефит кафе', text: 'Вкусные бонусы и предложения', icon: '/img/home-v2/png/benefit_cafe.png', to: '/benefit-cafe'},
            {title: 'Маркировка', text: 'Сканирование кодов товаров', icon: '/img/home-v2/png/markirovka.png', iconLarge: true, to: '/marking'},
            {title: 'Поддержка', text: 'Чат поддержки и HR внутри', icon: '/img/home-v2/png/podderzhka.png', onClick: () => this.setState({quickSheet: 'support'})},
            {title: 'Карьера', text: 'Рост, вакансии, развитие', icon: '/img/home-v2/png/kariera.png', onClick: () => this.setState({quickSheet: 'career'})},
        ];

        return <div className='home-actions-list'>{actions.map(item => this.renderHomeAction(item))}</div>;
    }

    renderQuickSheet() {
        const sheet = this.state.quickSheet;
        if (!sheet) {
            return null;
        }

        const isSupport = sheet === 'support';
        const title = isSupport ? 'Поддержка' : 'Карьера';
        const items = isSupport
            ? [
                {title: 'Чат технической поддержки', text: 'Создать тикет или открыть переписку', to: '/support'},
                {title: 'Отдел по работе с сотрудниками', text: 'Написать по рабочим вопросам', to: '/hr-feedback'},
            ]
            : [
                {title: 'Вакансии', text: 'Посмотреть открытые возможности', to: '/vacancies'},
                {title: 'Привести друга', text: 'Рекомендовать кандидата', to: '/staff-offer'},
            ];

        return (
            <div className='home-sheet-overlay' onClick={() => this.setState({quickSheet: ''})}>
                <div className='home-sheet' onClick={(event: any) => event.stopPropagation()} role='dialog' aria-modal='true'>
                    <div className='home-sheet-handle'></div>
                    <div className='home-sheet-title'>{title}</div>
                    <div className='home-sheet-list'>
                        {items.map(item => (
                            <Link key={item.to} to={item.to} className='home-sheet-link'>
                                <span>
                                    <strong>{item.title}</strong>
                                    <small>{item.text}</small>
                                </span>
                                <span>›</span>
                            </Link>
                        ))}
                    </div>
                    <button type='button' className='home-sheet-close' onClick={() => this.setState({quickSheet: ''})}>Закрыть</button>
                </div>
            </div>
        );
    }

    renderHomeHeader() {
        return (
            <div className='home-v2-hero'>
                <div className='home-v2-topbar'>
                    <div className='home-v2-identity'>
	                        <Link to='/profile' className='home-v2-avatar-link' aria-label='Открыть профиль мастера'>
	                            {this.state.headerAvatarUrl ? (
	                                <img
	                                    src={this.state.headerAvatarUrl}
	                                    alt={this.state.headerProfileName || 'Мастер'}
	                                    onError={() => this.setState({headerAvatarUrl: ''})}
	                                />
	                            ) : (
	                                <span>{this.initials(this.state.headerProfileName)}</span>
	                            )}
                        </Link>
                        <img className='home-v2-logo' src='/img/home-v2/logo-header.png' alt='Чио Чио'/>
                    </div>
                    <Link to='/notifications' className='home-v2-notifications' aria-label='Уведомления'>
                        <img src='/img/home-v2/bell.svg' alt=''/>
                        {this.state.notificationUnreadCount > 0 && (
                            <span className='home-notifications-badge'>
                                {this.formatNotificationBadge(this.state.notificationUnreadCount)}
                            </span>
                        )}
                    </Link>
                </div>
                <div className='home-v2-stats'>
                    <Link to='/chiocoins-history' className='home-v2-stat'>
                        <img src='/img/home-v2/png/chicoiny.png' alt=''/>
                        <span>Чиокоины</span>
                        <strong>{Number(this.state.chioCoin || 0).toLocaleString('ru-RU')}</strong>
                    </Link>
                    <Link to='/tips' className='home-v2-stat'>
                        <img src='/img/home-v2/png/chaevye.png' alt=''/>
                        <span>Чаевые</span>
                        <strong>{this.money(this.state.tipsToday)}</strong>
                    </Link>
                    <a href={EMPLOYEE_BOOK_URL} target='_blank' rel='noopener noreferrer' className='home-v2-stat home-v2-book'>
                        <img src='/img/home-v2/png/kniga_sotrudnika.png' alt=''/>
                        <span>Книга</span>
                        <strong title='сотрудника'>сотрудника</strong>
                    </a>
                </div>
            </div>
        );
    }

    renderMoodModal() {
        if (!this.state.auth || this.state.moodSent || !this.state.moodModalOpen || this.state.introModalOpen) {
            return null;
        }

        return (
            <div className='intro-modal-overlay mood-modal-overlay' role='dialog' aria-modal='true' aria-labelledby='mood-modal-title' aria-describedby='mood-modal-subtitle'>
                <div className='intro-modal mood-modal'>
                    <div className='intro-modal-content mood-modal-content'>
                        <button
                            className='mood-modal-close'
                            onClick={() => this.setState({moodModalOpen: false})}
                            aria-label='Закрыть'
                            type='button'
                            disabled={this.state.moodSubmitting}
                        >
                            ×
                        </button>
                        <h2 className='mood-modal-title' id='mood-modal-title'>Как дела?</h2>
                        <p className='mood-modal-subtitle' id='mood-modal-subtitle'>Поделитесь настроением — это поможет сделать рабочий день лучше.</p>
                        <div className='mood-modal-actions'>
                            {this.getMoodItems().map(item => (
                                <button
                                    key={item.key}
                                    type='button'
                                    onClick={() => this.submitMood(item.key)}
                                    className={'mood-modal-button ' + (this.state.selectedMood === item.key ? 'is-selected' : '')}
                                    aria-pressed={this.state.selectedMood === item.key}
                                    disabled={this.state.moodSubmitting}
                                >
                                    <span className='mood-modal-emoji' aria-hidden='true'>{item.icon}</span>
                                    <span className='mood-modal-label'>{item.label}</span>
                                </button>
                            ))}
                        </div>
                        {this.state.moodSubmitting ? (
                            <div className='mood-modal-status' role='status'>Сохраняем ответ…</div>
                        ) : null}
                        {this.state.moodError ? (
                            <div className='mood-modal-error' role='alert'>{this.state.moodError}</div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.state.isLoad) {
            return (<Preloader></Preloader>)
        } else {
            return (
                <div className='main home home-redesign'>
                    {this.renderIntroModal()}
                    {this.renderMoodModal()}
                    <div className='content mx-w-content home-v2-content'>
                        {this.renderHomeHeader()}
                        {this.renderPlanningBlock()}
                        {this.renderRecordsBlock()}
                        {this.renderActionsList()}
                    </div>
                    <Link to='/create-record' className='home-fab' aria-label='Записать клиента'>
                        <img src='/img/home-v2/png/plus.png' alt=''/>
                    </Link>
                    {this.renderQuickSheet()}
                    <Menu></Menu>
                </div>
            )
        }
    }
}

export default Home;
